import { render, staticRenderFns } from "./PlanComponent.vue?vue&type=template&id=6319fb74&scoped=true"
import script from "./PlanComponent.vue?vue&type=script&lang=js"
export * from "./PlanComponent.vue?vue&type=script&lang=js"
import style0 from "./PlanComponent.vue?vue&type=style&index=0&id=6319fb74&prod&lang=css"
import style1 from "./PlanComponent.vue?vue&type=style&index=1&id=6319fb74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319fb74",
  null
  
)

export default component.exports